import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { CSSProperties } from "@material-ui/styles";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import TablePagination from "@saleor/components/TablePagination";
import { maybe, renderCollection } from "@saleor/misc";
import { ListProps } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";

import { BrandVerticalReport_brandDetails_edges_node } from "../../types/BrandVerticalReport";
const useStyles = makeStyles(
  theme => {
    const overflowing: CSSProperties = {
      overflow: "hidden",
      textOverflow: "ellipsis"
    };
    return {
      colMedium: {
        overflowing,
        width: "12em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      colNarrow: {
        overflowing,
        width: "8em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      colRow: {
        "& th": {
          fontWeight: 600 as 600,
          paddingBottom: theme.spacing(1),
          paddingTop: theme.spacing(1)
        }
      },
      colWide: {
        overflowing,
        width: "16em",
        [theme.breakpoints.down("md")]: {
          width: "auto"
        }
      },
      table: {
        tableLayout: "fixed"
      },
      tableRow: {
        cursor: "pointer"
      }
    };
  },
  { name: "BrandVerticalList" }
);

export interface BrandVerticalListProps extends ListProps {
  brandVerticals: BrandVerticalReport_brandDetails_edges_node[];
}

export const BrandVerticalList: React.FC<BrandVerticalListProps> = ({
  brandVerticals,
  onNextPage,
  onPreviousPage,
  onRowClick,
  onUpdateListSettings,
  pageInfo,
  settings,
  disabled
}) => {
  const colNum = 2;
  const classes = useStyles({});

  return (
    <>
      <ResponsiveTable className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCellHeader className={classes.colWide}>
              <FormattedMessage defaultMessage="Brand Name" />
            </TableCellHeader>
            <TableCellHeader className={classes.colWide}>
              <FormattedMessage defaultMessage="Vertical" />
            </TableCellHeader>
          </TableRow>
        </TableHead>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={colNum}
              settings={settings}
              hasNextPage={
                pageInfo && !disabled ? pageInfo.hasNextPage : undefined
              }
              onNextPage={onNextPage}
              onUpdateListSettings={onUpdateListSettings}
              hasPreviousPage={
                pageInfo && !disabled ? pageInfo.hasPreviousPage : undefined
              }
              onPreviousPage={onPreviousPage}
            />
          </TableRow>
        </TableFooter>
        <TableBody>
          {brandVerticals &&
            renderCollection(
              brandVerticals,
              brandVerticals => (
                <TableRow
                  className={!!brandVerticals ? classes.tableRow : undefined}
                  hover={!!brandVerticals}
                  key={brandVerticals ? brandVerticals.id : "skeleton"}
                  onClick={
                    brandVerticals
                      ? onRowClick(
                          btoa(`BrandPrivate:${atob(brandVerticals.id)}`)
                        )
                      : undefined
                  }
                >
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => brandVerticals.brand_name,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell>
                    {maybe<React.ReactNode>(
                      () => brandVerticals.vertical,
                      <Skeleton />
                    )}
                  </TableCell>
                </TableRow>
              ),
              () => (
                <TableRow>
                  <TableCell colSpan={colNum}>
                    <FormattedMessage defaultMessage="No Brand found" />
                  </TableCell>
                </TableRow>
              )
            )}
        </TableBody>
      </ResponsiveTable>
    </>
  );
};

export default BrandVerticalList;
